import { log } from './logger'

// How a visitor first arrived, remembered across the browse-then-sign-up gap so
// sign_up can be attributed to the growth loop that produced it. Without this the
// QR → follow → sign-up funnel has no final step.
export type SignupSource = 'qr' | 'invite_link' | 'friend_invite' | 'share_link' | 'organic'

const KEY = 'beacon_signup_source'

/**
 * First write wins: the route that brought someone in is the attribution, not
 * whatever they browsed to afterwards. Session-scoped, so it naturally expires
 * with the tab rather than mis-attributing a later visit.
 */
export function recordSignupSource(source: SignupSource) {
  try {
    if (!sessionStorage.getItem(KEY)) sessionStorage.setItem(KEY, source)
  } catch (err) {
    // Safari private mode throws on sessionStorage; attribution is best-effort.
    log('analytics', 'signup source unavailable', { error: String(err) })
  }
}

/** Reads and clears, so a second sign-up in the same tab isn't mis-attributed. */
export function takeSignupSource(): SignupSource {
  try {
    const stored = sessionStorage.getItem(KEY)
    sessionStorage.removeItem(KEY)
    return (stored as SignupSource | null) ?? 'organic'
  } catch {
    return 'organic'
  }
}
